import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import PharmacyPage from './PharmacyPage';
import PharmacyLitePage from './PharmacyLitePage';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Pharmacy router shim. Picks between Lite and Full mode based on the
 * tenant's pharmacy_mode capability:
 *   - role 'pharmacy' (legacy)  → always Full (inventory/purchase reqs)
 *   - role 'pharmacist'         → Lite or Full per tenant setting
 */
export default function PharmacyRouter() {
  const { user } = useAuth();
  const [mode, setMode] = useState(
    // 'pharmacy' role keeps the legacy Full inventory experience.
    // 'receptiondesk' always lands on Lite (no PR / PO / stores flow).
    user?.role === 'pharmacy' ? 'full'
      : user?.role === 'receptiondesk' ? 'lite'
      : null
  );

  const resolveMode = useCallback(async () => {
    if (user?.role === 'pharmacy' || user?.role === 'receptiondesk') return;
    try {
      const { data } = await axios.get(`${API}/api/clinic-ops/me/capabilities`, { withCredentials: true });
      setMode(data?.pharmacy_mode === 'full' ? 'full' : 'lite');
    } catch (_) {
      setMode('full');
    }
  }, [user?.role]);

  useEffect(() => { resolveMode(); }, [resolveMode]);

  if (mode === null) {
    return (
      <div className="h-screen flex items-center justify-center bg-zinc-50">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-700" />
      </div>
    );
  }
  return mode === 'lite' ? <PharmacyLitePage /> : <PharmacyPage />;
}
